"use client";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useEffect, Suspense } from "react";
import { Toaster } from "@/components/ui/sonner";
import { toast } from "sonner";

function ClientToasterComponent() {
  const sp = useSearchParams()
  const envio = sp.get("envio")
  const router = useRouter()
  const pathname = usePathname()

  useEffect(() => {
    if (envio && envio === "sucesso") {
      const redirect = () => router.replace(pathname, {
        scroll: false
      });
      toast.success("Seu relato foi enviado com sucesso! Obrigado pela contribuição.", {
        onAutoClose: redirect,
        onDismiss: redirect,
      });
    }
  }, [envio, router, pathname])

  return <Toaster position="bottom-center" theme="light" closeButton richColors />;
}

// evita https://nextjs.org/docs/messages/missing-suspense-with-csr-bailout
export default function ClientToaster() {
  return (
    <Suspense>
      <ClientToasterComponent />
    </Suspense>
  );
}